import { Speaker } from '@/integrations/supabase/client';
import davidGrovesImage from '@/assets/david-groves.jpg.asset.json';
import davidGrovesIbmLogo from '@/assets/david-groves-ibm-logo.png.asset.json';

export const speakers: Partial<Speaker>[] = [
  {
    id: "david-groves",
    name: "David Groves",
    slug: "david-groves",
    title: "Strategic AI Lead & Principal Data Scientist - AI & Analytics",
    company_name: "IBM",
    company_logo: davidGrovesIbmLogo.url,
    image_url: davidGrovesImage.url,
    bio: "David Groves is Strategic AI Lead & Principal Data Scientist - AI & Analytics at IBM, where he works with enterprises to turn data and AI into measurable business value, leading the design and delivery of AI and analytics solutions at scale.",
    topic: null,
    twitter_url: null,
    linkedin_url: null,
    github_url: null,
    conference_id: "default",
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: "philip-gaffney",
    name: "Dr Philip Gaffney OBE",
    slug: "philip-gaffney",
    title: "CEO",
    company_name: "Camgenium",
    company_logo: "/lovable-uploads/logo-camgenium.png",
    image_url: "/lovable-uploads/dr-philip-gaffney-obe.jpg",
    bio: "Dr Gaffney leads Camgenium (Camgenium is the trading name of L2S2 Ltd).\n\nHis deep knowledge of science, technology, health systems and quality compliance assist customers to develop new technologies and enter new markets quickly.\n\nHe is Cambridge educated, with a degree in natural sciences, followed by a PhD in geophysics and instrumentation and was a Research Fellow and Tutor at Churchill College, Cambridge. He was awarded an OBE for services to science and technology in 1997.\n\nHe has developed and built several high-tech businesses in Cambridge, including Seescan PLC (image processing and science research), Cambridge Advanced Electronics PLC and Camgenium.\n\nHe provides technical vision and drives the realization and commercialisation of good engineering for customers that want to compete successfully in global markets.\n\nDr Gaffney has developed has strong links between Camgenium and the University of Cambridge Department of Engineering. He lectures final year undergraduates reading medical device design. His links assist Camgenium to build its team of excellent graduates specialising in medical device applications and AI, further strengthening its world-class expert team.",
    topic: "Beyond Compliance: How Good Regulation Makes AI Better",
    twitter_url: null,
    linkedin_url: null,
    github_url: null,
    conference_id: "default",
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: "benjamin-summerfield",
    name: "Benjamin Summerfield",
    slug: "benjamin-summerfield",
    title: "Lead Data Scientist and Delivery Lead",
    company_name: "IBM",
    company_logo: "/lovable-uploads/logo-ibm.png",
    image_url: "/lovable-uploads/benjamin-summerfield.jpg",
    bio: "Benjamin Summerfield is Lead Data Scientist and Delivery Lead at IBM for 10+ years in both financial services and retail industries I have assisted Clients in realising value for AI by designing, scaling and delivering AI solutions into production and keeping them there.",
    topic: null,
    twitter_url: null,
    linkedin_url: null,
    github_url: null,
    conference_id: "default",
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: "12",
    name: "Akis Papageorgiou",
    slug: "akis-papageorgiou",
    title: "Chief AI Architect",
    company_name: "IBM",
    company_logo: "/lovable-uploads/186d8b85-4870-494e-82c9-5659f9285720.png",
    image_url: "/lovable-uploads/91d256cd-5d27-4c5d-82dd-79b48e75b54c.png",
    bio: "Akis Papageorgiou is based out of London, England, United Kingdom and works at IBM Associate Partner",
    topic: null,
    twitter_url: null,
    linkedin_url: null,
    github_url: null,
    conference_id: "default",
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: "4",
    name: "Marcus Vinicius Martinez",
    slug: "marcus-martinez",
    title: "EMEA, Worldwide Financial Services",
    company_name: "Microsoft",
    company_logo: "/__l5e/assets-v1/d41d5129-6151-4e52-b09d-54cac2fb08c6/speaker-logo-microsoft-cropped.png",
    image_url: "/lovable-uploads/c491ebf7-b6c6-4d3d-856d-27357271c705.png",
    bio: "Marcus is a seasoned industry advisor with over 20 years of experience in the financial services sector, renowned for driving digital transformation and innovation. His career is marked by a proven ability to lead high-impact initiatives for major organisations and financial institutions, focusing on regulatory compliance, enhancing customer experiences, and modernising payment platforms. In recent years, Marcus has become a thought leader in generative AI and cloud computing, building on his impactful tenure at Microsoft. There, he led transformative projects, including developing cutting-edge prompt engineering techniques to revolutionise sales effectiveness, reimagine business development, and optimise sales strategies. Passionate about bridging financial services and emerging technologies, Marcus is committed to empowering organisations to harness generative AI and cloud innovations, ensuring they thrive in an ever-evolving marketplace.",
    topic: null,
    twitter_url: null,
    linkedin_url: null,
    github_url: null,
    conference_id: "default",
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: "pip-white",
    name: "Pip White",
    slug: "pip-white",
    title: "Head of EMEA North",
    company_name: "Anthropic",
    company_logo: "/lovable-uploads/logo-anthropic.png",
    image_url: "/lovable-uploads/pip-white.jpg",
    bio: "Pip White, is the Head of EMEA North at Anthropic, where she leads the go-to-market efforts across the UK and Ireland, Benelux, Nordics, and Israel, working from London office. Pip brings 25 years of enterprise technology experience from companies including Salesforce, Google, and Slack, where she drove significant growth across UK and EMEA markets.",
    topic: null,
    twitter_url: null,
    linkedin_url: null,
    github_url: null,
    conference_id: "default",
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: "1",
    name: "Liran Zvibel",
    slug: "liran-zvibel",
    title: "Cofounder & CEO",
    company_name: "WEKA",
    company_logo: "/lovable-uploads/74002c2e-e085-4385-bbfb-335c04d64028.png",
    image_url: "/lovable-uploads/52e7c878-4201-4f37-a3ca-50ef918c3f22.png",
    bio: "Liran is co-founder and CEO of WEKA, where he guides the company's long-term vision and strategy. Before establishing WEKA, Liran co-founded and led research and development at social startup Fusic, where he was responsible for the engineering, design, and development of its rich social media application portfolio. Prior to Fusic, Liran was the principal software architect and a founding member of the technical team at XIV Storage Systems before its acquisition by IBM in 2007; he then managed XIV's hardware and platform teams at IBM for several years.\n\nBefore joining XIV, Liran served as a Software Engineer with the rank of Captain in the Israeli Defense Forces for five years. He earned a Bachelor of Science degree in Mathematics and Computer Science from Tel Aviv University.",
    topic: "Future of AI Infrastructure",
    twitter_url: null,
    linkedin_url: null,
    github_url: null,
    conference_id: "default",
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: "3",
    name: "Kanishka Narayan",
    slug: "kanishka-narayan-mp",
    title: "Member of Parliament",
    company_name: "UK Parliament",
    company_logo: "/lovable-uploads/e2a9bf7e-906e-4264-9cff-cf8a4bc3b341.png",
    image_url: "/lovable-uploads/10e4a22e-5f22-40e0-b16d-26bb0609d3a8.png",
    bio: "Kanishka is the Labour MP for the Vale of Glamorgan, after a career in senior government and private sector roles.\n\nIn government, Kanishka advised ministers on domestic public policy, as Senior Adviser at the Cabinet Office and as Expert Adviser to Britain's Environment Secretary. He also advised the Labour Party frontbench as Head of Tech Policy.\n\nIn business, Kanishka advised and invested in climate and fintech start-ups across Europe and the US, and previously advised FTSE boards, sovereign finance ministries and start-up founders at Lazard.\n\nKanishka grew up and lives in South Wales, studied at Oxford and Stanford universities, and is passionate about social mobility and social justice. He ran a national campaign to help British high streets during the national COVID-19 lockdown and has published national research on helping households in severe debt.",
    topic: null,
    twitter_url: null,
    linkedin_url: null,
    github_url: null,
    conference_id: "default",
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: "7",
    name: "Tejas Joshi",
    slug: "tejas-joshi",
    title: "CTO, Data Platform & AI",
    company_name: "Oracle",
    company_logo: "/__l5e/assets-v1/6ed4a92c-5c82-480b-815e-0061386530a2/speaker-logo-oracle-cropped.png",
    image_url: "/lovable-uploads/1696dfb7-9388-4f37-bd2d-d5f5d4b9b089.png",
    bio: "As the Chief Technology Officer (CTO) of Data Platform and AI, Tejas Joshi leads Oracle's strategic initiatives in harnessing the power of data and artificial intelligence (AI) technologies. With over 22 years of experience in technology leadership, Tejas is a seasoned expert in driving innovation and delivering transformative solutions across various industries.\n\nTejas's role involves spearheading the development of Oracle's data platform and AI capabilities, with a focus on empowering organizations to leverage these technologies for enhanced decision-making, operational efficiency, and customer experiences. He collaborates closely with industry leaders to understand their unique challenges and opportunities, crafting tailored AI solutions that drive tangible business value.\n\nAs a trusted advisor and thought leader, Tejas is frequently sought after to share his insights on AI and its potential to drive positive impact across businesses. His pragmatic approach, coupled with a deep understanding of industry dynamics, ensures that Oracle remains at the forefront of AI innovation, empowering organizations to thrive in an increasingly data-driven world.",
    topic: null,
    twitter_url: null,
    linkedin_url: null,
    github_url: null,
    conference_id: "default",
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: "8",
    name: "Marta Janus",
    slug: "marta-janus",
    title: "Principal Adversarial ML Researcher",
    company_name: "Hidden Layer",
    company_logo: "/lovable-uploads/9de5a4c4-5054-411f-84e7-71b768194a8f.png",
    image_url: "/lovable-uploads/2c124c6e-a7b5-4b7f-8cac-8828c073617d.png",
    bio: "An experienced threat researcher with long stints at both Kaspersky and Cylance, Marta Janus has the full arsenal of skills for tracking adversaries and dissecting code. She's got years of experience in reverse-engineering software and firmware, in threat hunting, and in uncovering obfuscation and anti-reversing techniques.\n\nNow she's setting her sights on the emerging field of adversarial machine learning and adversarial AI research for startup HiddenLayer. She's part of the company's Synaptic Adversarial Intelligence (SAI) team, which has helped drive the company's direction in developing a platform to detect attacks against ML systems.\n\nIt's a bleeding edge field of research and the platform was recently named as a finalist for the Innovation Sandbox awards at the RSA Conference next month. On the publicly released research front, Janus hit the ground running after joining the team last year. In December, she and her teammates put out a proof-of-concept (POC) report about how a threat actor could use PyTorch ML models to infiltrate enterprise networks.",
    topic: null,
    twitter_url: null,
    linkedin_url: null,
    github_url: null,
    conference_id: "default",
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: "9",
    name: "Nayur Khan",
    slug: "nayur-khan",
    title: "Partner - QuantumBlack, AI by McKinsey",
    company_name: "McKinsey",
    company_logo: "/lovable-uploads/408d8289-bd09-4c06-bc07-6bfb17974f18.png",
    image_url: "/lovable-uploads/9f351890-2058-4cf6-b8e2-62c11def1f99.png",
    bio: "Nayur is a partner with firm's London office and also part of the QuantumBlack, AI by McKinsey team. He is predominantly focused on helping organizations build capabilities to industrialize and scale artificial intelligence (AI) to improve performance. He also helps companies navigate innovations, technologies, processes, and digital skills as needed.\n\nHis work has spanned several sectors and industries, from energy and pharmaceuticals to healthcare and life sciences, finance, and retail. He assists organizations move away from pilots and experiments with AI to industrialized implementations that run reliably at scale.\n\nBefore joining QuantumBlack, Nayur helped organizations by driving strategies and implementations with data, machine learning, and AI to digital change and impact. He has built and led multiple engineering teams made up of differing skills and disciplines to deliver complex technology solutions and products.",
    topic: null,
    twitter_url: null,
    linkedin_url: null,
    github_url: null,
    conference_id: "default",
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: "10",
    name: "Oliver King-Smith",
    slug: "oliver-king-smith",
    title: "CEO",
    company_name: "smartR AI",
    company_logo: "/lovable-uploads/c5bab049-6762-4e83-a765-504f23367550.png",
    image_url: "/lovable-uploads/11bc1266-3b99-424d-9101-c19b685c0bf0.png",
    bio: "Oliver King-Smith is a Technical manager with extensive experience working with new software and hardware projects. His focus is AI / ML for IoT devices.\n\nCurrently working on new Data Efficient Reinforcement Learning algorithms. Enabling the computer to solve control problems is an exciting and active area of research. At the cutting edge, algorithms can match and exceed the ability of top programmers to solve control problems.\n\nSpecialties: Management of technical teams, Mathematics, Computer Science and AI.",
    topic: "Data Efficient Reinforcement Learning for IoT Devices",
    twitter_url: null,
    linkedin_url: null,
    github_url: null,
    conference_id: "default",
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: "11",
    name: "Soren F Mortensen",
    slug: "soren-f-mortensen",
    title: "Transformation Director",
    company_name: "IBM",
    company_logo: "/lovable-uploads/186d8b85-4870-494e-82c9-5659f9285720.png",
    image_url: "/lovable-uploads/c97dd397-963c-494c-acf9-cee08e9233d6.png",
    bio: "Soren F Mortensen has worked in the IT & Financial Industry for the last twenty years. With a Masters degree in International Management & Finance from the Thunderbird School of Global Management and education from Copenhagen Business School, Soren has held key positions at major organizations including IBM, Morgan Stanley, and Paribas Capital Markets. Currently serving as Transformation Director at IBM, he specializes in customizing IBM solutions for large-scale projects. Throughout his career, Soren has demonstrated expertise in financial markets, particularly in banking & insurance, while maintaining strong connections across Europe's multicultural business environment. He is fluent in seven languages and has a deep understanding of international business operations.",
    topic: "Digital Transformation in Financial Markets",
    twitter_url: null,
    linkedin_url: null,
    github_url: null,
    conference_id: "default",
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: "13",
    name: "Charles \"Chuck\" Ahlborn",
    slug: "charles-chuck-ahlborn",
    title: "MPS Lead for AL/ML Cyber Risk and Assurance",
    company_name: "Metropolitan Police",
    company_logo: "/lovable-uploads/fbf302df-041b-4b17-a8ff-01694fdf9251.png",
    image_url: "/lovable-uploads/cfa9db8d-6a49-4291-af4a-4b2c972aa11a.png",
    bio: "Charles \"Chuck\" Ahlborn leads the Artificial Intelligence and Machine Learning Cyber Risk and Assurance team at the Metropolitan Police Service. With extensive experience in cybersecurity and AI risk management, Chuck specializes in developing and implementing frameworks to ensure the safe, ethical, and secure deployment of AI systems within law enforcement contexts. His work focuses on identifying and mitigating potential vulnerabilities in AI/ML applications while ensuring compliance with relevant regulations and standards. Chuck regularly collaborates with government agencies, academic institutions, and industry partners to establish best practices for AI governance and security in critical public safety systems.",
    topic: "Cyber Defense in AI/ML Systems",
    twitter_url: null,
    linkedin_url: null,
    github_url: null,
    conference_id: "default",
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: "14",
    name: "Jim Morrish",
    slug: "jim-morrish",
    title: "Founding Partner",
    company_name: "Transforma Insights",
    company_logo: "/lovable-uploads/2cf8b7e2-7706-4a10-9ba9-566685cb9a34.png",
    image_url: "/lovable-uploads/d9b6d224-5d58-4f23-acb6-16a94e394b29.png",
    bio: "Jim Morrish is Founding Partner of Transforma Insights, the leading research company focused on the world of Digital Transformation, covering IoT, 5G, Cloud and Edge Computing and Digital Transformation more broadly. He was previously Head of Machine-to-Machine (M2M) Research at Informa Telecoms & Media, which was subsequently acquired by Omdia, where he built the world's leading M2M/IoT analyst practice.\n\nJim has 25 years of experience as a technology industry analyst. Prior to joining Informa, he was an equity research analyst at Polar Capital covering European technology stocks, and before that he held a variety of strategy, product marketing and product management positions at technology companies including Thus plc (now Vodafone UK), Parc Technologies and Marconi. He has an MBA from London Business School and an MA in Natural Sciences from Cambridge University.",
    topic: "Opportunities in AIoT: AI onboard IoT devices",
    twitter_url: null,
    linkedin_url: null,
    github_url: null,
    conference_id: "default",
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: "16",
    name: "Chris Eastham",
    slug: "chris-eastham",
    title: "Partner",
    company_name: "Fieldfisher",
    company_logo: "/lovable-uploads/f86ec3d7-ec09-46bd-b9c1-407af42c76a8.png",
    image_url: "/lovable-uploads/b5b96404-1e23-4816-834b-3a24fd6cc5c5.png",
    bio: "Chris Eastham is a Partner in the Technology & Data group at the law firm Fieldfisher. In his legal practice, he advises both customers and vendors on technology-related matters, providing commercial and pragmatic legal solutions to enable them to achieve their strategic goals. He is an expert in negotiating complex technology contracts—especially for business critical systems and functions. He has in-depth experience in the telecoms sector, and of AI, automation, robotics, AR/VR/XR, and other emerging technologies.\n\nChris has first class degrees in Physics with Space Science and Technology (MPhys), and in Law (LLB).",
    topic: "Legal frameworks for AI and emerging technologies",
    twitter_url: null,
    linkedin_url: null,
    github_url: null,
    conference_id: "default",
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: "17",
    name: "Ian Glazebrook",
    slug: "ian-glazebrook",
    title: "Technical Director",
    company_name: "AtkinsRéalis",
    company_logo: "/lovable-uploads/8cce82f7-7203-4c56-b2f0-3650383f020e.png",
    image_url: "/lovable-uploads/2673eca1-3517-4dc1-9295-ac40b7c8e01a.png",
    bio: "Ian Glazebrook has worked on critical software and complex electronic systems for nearly 30 years and is a Chartered Engineer (CEng) with the Institute of Engineering and Technology (MIET) and Fellow of the British Computer Society (FBCS). He is a Technical Director within the Aerospace, Defence, Security and Technology business at AtkinsRéalis.\n\nHe has experience of developing and the independent assessment of safety critical and novel systems across a range of sectors and integrity requirements including Civil Nuclear, Defence, Maritime and Rail. He has written and presented numerous papers and been involved in drafting national and international standards and guidance. He has experience of software and complex hardware systems written in most programming languages including Ada, C, C++, C#, Verilog, Simulink, SCADE, VHDL and Java",
    topic: "Safety Critical Systems and AI",
    twitter_url: null,
    linkedin_url: null,
    github_url: null,
    conference_id: "default",
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: "19",
    name: "Jay Cruiz",
    slug: "jay-cruiz",
    title: "CSO",
    company_name: "AmpiFire",
    company_logo: "/lovable-uploads/ampfire-logo.jpg",
    image_url: "/lovable-uploads/jay-cruiz-2025.jpg",
    bio: "Jay Cruiz is a world-renowned expert in AI-powered organic traffic generation and keynote speaker who has delivered hundreds of talks worldwide. As co-creator of AmpCast AI by Ampifire.com, the only platform combining advanced AI with full-scale, multi-channel content distribution, Jay has helped businesses generate millions in organic traffic value. His proven systems capture traffic from Google, YouTube, social media, podcasts, and 300+ high-authority sites without ad spend. Jay has guided agencies to 7-figure revenues and e-commerce brands to 50x ROI through strategic organic content. He translates complex AI strategies into actionable frameworks backed by real-world data and measurable results, helping professionals master predictable, scalable organic traffic growth in the AI era.",
    topic: "The Art of Persuasion and Digital Marketing",
    twitter_url: null,
    linkedin_url: null,
    github_url: null,
    conference_id: "default",
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: "20",
    name: "Becky Davis",
    slug: "becky-davis",
    title: "Consulting Director - AI Practice",
    company_name: "Sopra Steria",
    company_logo: "/lovable-uploads/logo-soprasteria.svg",
    image_url: "/lovable-uploads/becky-davis.jpg",
    bio: "Becky is the Director of AI at Sopra Steria Next, where she leads initiatives that harness the transformative power of artificial intelligence to drive innovation.\n\nIn her role, Becky brings over 20 years of experience in business transformation to our AI-driven projects, integrating advanced technologies like generative AI to solve complex challenges and optimise operations.\n\nPassionate about responsible AI, Becky is committed to ensuring that the technology is developed and deployed ethically, with a clear focus on improving people's lives. Her work is particularly focused on how AI can enhance operational efficiency, accelerate digital transformation, and create positive societal outcomes. In 2024 she was the key speaker on a webinar about AI: A human conversation ran by Sopra Steria.",
    topic: "Gen AI for Operational Efficiency and Digital Transformation",
    twitter_url: null,
    linkedin_url: null,
    github_url: null,
    conference_id: "default",
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: "21",
    name: "Dr. Jeremy Sosabowski",
    slug: "jeremy-sosabowski",
    title: "Chief Executive Officer",
    company_name: "AlgoDynamix",
    company_logo: "/lovable-uploads/logo-algodynamix.png",
    image_url: "/lovable-uploads/jeremy-sosabowski.jpg",
    bio: "Jeremy has over a decade of business and technology commercialisation experience. His previous roles include CTO at an instrumentation company (technology acquired) and data analyst within the online transaction space. His 'IP portfolio' includes several granted patents and more than ten peer reviewed publications. Education: University of Cambridge Engineering PhD and Signal Processing MSc from University of Bristol.",
    topic: "AI Forecasts in Finance & Crypto",
    twitter_url: null,
    linkedin_url: null,
    github_url: null,
    conference_id: "default",
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: "22",
    name: "Mark Sage",
    slug: "mark-sage",
    title: "Executive Director",
    company_name: "AREA",
    company_logo: "/lovable-uploads/logo-area.png",
    image_url: "/lovable-uploads/mark-sage.jpg",
    bio: "Mark Sage is the founder and managing director of Sagey11 Ltd. His company provides strategic and operational consulting on marketing and business development, focusing on building lasting partnerships especially for technology start-up and scale-up companies. He has worked with and led various alliances and associations primarily in the mobile operating system space (including Tizen Association and Symbian Foundation).\n\nWith a focus on building long-term relationships and offering value and ROI for its members, his goal is to develop a robust and active ecosystem for AR within the enterprise.",
    topic: "Exploring Intersection of AI and AR",
    twitter_url: null,
    linkedin_url: null,
    github_url: null,
    conference_id: "default",
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: "23",
    name: "Javier Campos",
    slug: "javier-campos",
    title: "Group CTO",
    company_name: "CAPE",
    company_logo: "/lovable-uploads/logo-cape.png",
    image_url: "/lovable-uploads/javier-campos.jpg",
    bio: "Campos has built an impressive track record across the global AdTech and media ecosystem, having held senior technology leadership positions at Experian DataLabs (EMEA), Kantar-WPP (Global CTO), GroupM-WPP (EMEA CIO) and Havas (CTO). He began his career at Accenture, establishing a foundation in enterprise transformation that has informed his approach throughout his career.\n\nAs an established AI thought leader, Campos authored \"Grow Your Business with AI\" (2023) and has a forthcoming book \"Autonomous Minds\" scheduled for release in October 2025. Beyond his commercial roles, he contributes to AI safety research at the Cambridge AI Safety Hub, working to ensure safety protocols evolve alongside frontier AI models.",
    topic: "Autonomous Minds: How Agentic AI Predicts and Learns to Enable Productivity and Empowerment",
    twitter_url: null,
    linkedin_url: null,
    github_url: null,
    conference_id: "default",
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: "24",
    name: "Ramyani Basu",
    slug: "ramyani-basu",
    title: "Senior partner Data & AI",
    company_name: "Kearney",
    company_logo: "/lovable-uploads/logo-kearney.jpg",
    image_url: "/lovable-uploads/ramyani-basu.jpg",
    bio: "Ramyani Basu, senior partner in Kearney's Data & AI practice, leads large-scale digital and AI transformations that redefine enterprise value across industries, including banking, consumer goods, pharmaceuticals, and heavy process sectors, helping organizations harness data, automation, and advanced analytics to drive sustainable competitive advantage. Ramyani is a global digital and AI advisor, with proven results in combining deep expertise in AI, data strategy, and business transformation to help boards and CXOs deliver sustained, future-ready impact.\n\nAs a recognized thought leader — including contributions to the Harvard Business Review — she has a strong focus on future-back, customer-led technology innovation and co-leads Kearney's AI executive education program with Carnegie Mellon University. She is also an advocate for diversity, equity, and inclusion, championing equitable leadership at Kearney and co-leading initiatives such as the firm's International Women's Day Forum in partnership with UN Women UK.",
    topic: "AI and Data-Driven Transformation",
    twitter_url: null,
    linkedin_url: null,
    github_url: null,
    conference_id: "default",
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: "scott-rowlandson",
    name: "Scott Rowlandson",
    slug: "scott-rowlandson",
    title: "CEO and Founder",
    company_name: "NetOrca",
    company_logo: "/lovable-uploads/logo-netorca.svg",
    image_url: "/lovable-uploads/scott-rowlandson-new.jpg",
    bio: "After 20 years' experience in networking and software development, Scott founded NetAutomate in 2019 assembling a global team of consultants dedicated to delivering tactical automation solutions for large enterprises. Under his leadership, the company has built a strong reputation for consistent success across multiple industries, particularly within financial services, through its focus on pragmatic, outcome-driven automation delivery.\n\nAfter identifying recurring challenges across enterprise automation programs, Scott led the design and development of NetOrca, NetAutomate's flagship orchestration platform. NetOrca was created to simplify and unify complex automation ecosystems, enabling enterprises to manage and scale automation more intelligently.\n\nIn 2023, the platform went live within a top-four UK bank, where it now processes over 10,000 automation changes annually. Building on this success, the platform's next evolution is centered around agentic AI-driven configuration generation, marking a significant step toward fully autonomous enterprise automation.\n\nScott is also a seasoned conference speaker, podcast guest, and expert panellist, recognised as an automation evangelist and thought leader in the intersection of AI and enterprise automation.",
    topic: "AI and Enterprise Automation",
    twitter_url: null,
    linkedin_url: null,
    github_url: null,
    conference_id: "default",
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: "mo-hamdy",
    name: "Mo Hamdy",
    slug: "mo-hamdy",
    title: "Founder & CEO",
    company_name: "Bexprt",
    company_logo: "/__l5e/assets-v1/d76c0087-5935-400c-8a77-718c8b99be60/bexprt-logo.png",
    image_url: "/__l5e/assets-v1/9f69c986-b905-4354-9b58-b9577ed89b79/mo-hamdy.jpg",
    bio: "25+ years' commercial experience in multinational enterprise, Telco and MSP segments, focussed on holistic, value-based sales (Huawei, Safran, Giesecke+Devrient).\n\nManagement consultancy for startups and SMBs, focussed on commercial and GTM strategy: Digis Squared, Aspire Technologies.\n\nExtensive experience in UK, Europe, LATAM, and the wider Middle East / Africa region. Designed and deployed integrated account development plans and business development initiatives in 80+ countries.\n\nFluent in executive engagement strategies in Tier 1 CSPs and Fortune 500 enterprises globally.\n\nMBA. BSc Electronics & Communications Engineering.",
    topic: null,
    twitter_url: null,
    linkedin_url: null,
    github_url: null,
    conference_id: "default",
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: "yael-misrahi",
    name: "Yael Misrahi",
    slug: "yael-misrahi",
    title: "Commercial Lead EMEA+APAC, Elsevier",
    company_name: "Elsevier",
    company_logo: "/__l5e/assets-v1/13374f64-464a-49ce-9daa-f37507d67c2b/logo-elsevier.svg",
    image_url: "/__l5e/assets-v1/2a0b19ce-73c9-49fb-a5a0-f67260b61c13/yael-misrahi.jpg",
    bio: "Yael Misrahi spearheads MobileODT's global partnerships focusing on the scalable and sustainable implementation of MobileODT's digital AI/ML solutions in health systems. Yael's background is in international relations and she has worked with international organizations including Innovation: Africa, the American Jewish World Service and the Israeli Fund for UNICEF, specializing in introducing new digital technologies to low-resource settings. Yael grew up in the United States and has lived and worked extensively in Israel, sub-Saharan Africa, Central America and India. Yael holds a B.A. from Wellesley College in International Relations and an M.A. (Cumme Laude) from IDC-Herzliya.",
    topic: null,
    twitter_url: null,
    linkedin_url: null,
    github_url: null,
    conference_id: "default",
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: "nick-smirnov",
    name: "Nick Smirnov",
    slug: "nick-smirnov",
    title: "CEO",
    company_name: "Hystax",
    company_logo: "/__l5e/assets-v1/6dcc1ad9-ffe0-4f77-b650-9123fa1a343e/hystax-logo.png",
    image_url: "/__l5e/assets-v1/4030e581-0efd-4162-9c68-7428e05b9ce1/nick-smirnov.jpg",
    bio: "Nick Smirnov, CEO at Hystax, and Max Bozhenko, CTO and Engineering Manager who's been running Engineering teams for more than 10 years.",
    topic: null,
    twitter_url: null,
    linkedin_url: null,
    github_url: null,
    conference_id: "default",
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: "peter-muld",
    name: "Peter Muld",
    slug: "peter-muld",
    title: "Chief Information Officer (CIO) of ICA Gruppen",
    company_name: "ICA Gruppen",
    company_logo: "/__l5e/assets-v1/4a03dff4-2efd-4971-94c4-5a2c88f2a17b/ica-logo.png",
    image_url: "/__l5e/assets-v1/3b619461-2543-4780-a6ed-df8e8377c6d7/peter-muld.jpg",
    bio: "Peter Muld is the Chief Information Officer (CIO) of ICA Gruppen and ICA Sweden, having assumed the role on 1 January 2024. Since joining ICA in 2016, he has held several senior leadership positions across digital transformation, strategy, and technology, including Chief Digital Officer of ICA Gruppen and Head of Strategy & Transformation at ICA Sweden. With extensive experience driving business-led digital innovation, Peter plays a key role in shaping ICA's technology strategy and long-term transformation agenda.\n\nAs CIO, Peter is leading ICA's new Digital & Technology organisation, bringing together previously separate IT functions into a unified, business-focused operation. His focus is on leveraging technology, data, and digital capabilities to strengthen customer experiences, support ICA stores, improve operational efficiency, and accelerate innovation across one of the Nordic region's largest retail groups.",
    topic: null,
    twitter_url: null,
    linkedin_url: null,
    github_url: null,
    conference_id: "default",
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  }
];



